<template>
  <v-app class="ma-0">
    <snack-bar />
    <v-app-bar app color="primary" height="60" style="z-index:9">
      <div>
        <v-img
          class="d-flex d-sm-none mx-auto my-auto"
          src="logoHorizontalBranco.svg?raw"
          width="70"
        ></v-img>
        <v-img
          class="d-none d-sm-flex mx-auto my-auto"
          src="logoHorizontalBranco.svg?raw"
          width="90"
        ></v-img>
      </div>
      <span
        class="headline mx-3 font-weight-bold white--text mt-2 d-none d-sm-flex"
      >
        Tribunal de Contas do Distrito Federal
      </span>
      <span
        class="d-flex d-sm-none font-weight-bold text-center white--text mx-auto mt-1"
        style="font-size: 14px;"
        >Tribunal de Contas do Distrito Federal</span
      >
    </v-app-bar>
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>
<script>
import SnackBar from "@/shared/SnackBar";

export default {
  components: {
    SnackBar
  },
  data: () => ({}),
  methods: {
    home() {
      this.$router.push("/");
    }
  }
};
</script>
<style lang="scss">
@import "@/style.scss";
</style>
